export default __webpack_public_path__ + "static/6-7011598086da797579f435a733eefebd.png";